module.exports = "./img/d94b50e8da65bfc1a6b283fba317bcb4.jpg";